@if (voucherData) {
<pdf-voucher-template [data]="pdfVoucher" [color]="color" />
}
